import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  imageBaseUrl: string = environment.imageBaseUrl;

  busPackagesArr: any = [
    { "id": 1, "tourName": "Goa Mahabaleshver Lonavala Emejika / Matheran", "tourImageUrl": this.imageBaseUrl + "/BusPackages/1.jpeg" },
    { "id": 2, "tourName": "Mahabaleshver Lonavala Emejika / Matheran  -  Lonavala Emejika / Matheran Goa", "tourImageUrl": this.imageBaseUrl + "/BusPackages/2.jpeg" },
    // { "id": 3, "tourName": "Lonavala Emejika / Matheran Goa", "tourImageUrl": this.imageBaseUrl + "/BusPackages/3.jpeg" },
    { "id": 4, "tourName": "Udaipur Ranthambore Abu Ambaji  -  Jodhpur Jaisalmer Desert Sam", "tourImageUrl": this.imageBaseUrl + "/BusPackages/4.jpeg" },
    // { "id": 5, "tourName": "Jodhpur Jaisalmer Desert Sam", "tourImageUrl": this.imageBaseUrl + "/BusPackages/5.jpeg" },
    { "id": 6, "tourName": "Jaipur Bikaner Jaisalmer Jodhpur", "tourImageUrl": this.imageBaseUrl + "/BusPackages/6.jpeg" },
    { "id": 7, "tourName": "Ujjain Pachmarhi Indore Omkareshwar", "tourImageUrl": this.imageBaseUrl + "/BusPackages/7.jpeg" },
    { "id": 8, "tourName": "Express Simla Kullu Manali Delhi", "tourImageUrl": this.imageBaseUrl + "/BusPackages/8.jpeg" },
    { "id": 9, "tourName": "Simla Kullu Manali Delhousey Amrutsar", "tourImageUrl": this.imageBaseUrl + "/BusPackages/9.jpeg" },
    { "id": 10, "tourName": "Agra Delhi Simla Manali Delhousey Dharamshala Amrutsar", "tourImageUrl": this.imageBaseUrl + "/BusPackages/10.jpeg" },
    { "id": 11, "tourName": "VaishnoDevi Simla Kullu Manali Amrutsar", "tourImageUrl": this.imageBaseUrl + "/BusPackages/11.jpeg" },
    { "id": 12, "tourName": "Kashmir Simla Kullu Manali Amrutsar", "tourImageUrl": this.imageBaseUrl + "/BusPackages/12.jpeg" },
    { "id": 13, "tourName": "Kashmir Shrinagar", "tourImageUrl": this.imageBaseUrl + "/BusPackages/13.jpeg" },
    { "id": 14, "tourName": "Kerala Munnar Thekkady Thiruvananthapuram", "tourImageUrl": this.imageBaseUrl + "/BusPackages/14.jpeg" },
    { "id": 15, "tourName": "Bangalore Mysore Ooty Coorg Kodaikanal", "tourImageUrl": this.imageBaseUrl + "/BusPackages/15.jpeg" },
    { "id": 16, "tourName": "Express Haridwar Mathura Agra", "tourImageUrl": this.imageBaseUrl + "/BusPackages/16.jpeg" },
    { "id": 17, "tourName": "Nainital Haridwar Mathura Agra", "tourImageUrl": this.imageBaseUrl + "/BusPackages/17.jpeg" },
    { "id": 18, "tourName": "Saptjyotirling South india Rameshvar Tirupati", "tourImageUrl": this.imageBaseUrl + "/BusPackages/18.jpeg" },
    { "id": 19, "tourName": "Gangasagar Kolkata Champaran JagannathPuri", "tourImageUrl": this.imageBaseUrl + "/BusPackages/19.jpeg" },
    { "id": 20, "tourName": "Nepal Pokhara Banaras Allahabad", "tourImageUrl": this.imageBaseUrl + "/BusPackages/20.jpeg" },
    { "id": 21, "tourName": "Nepal Pokhara Kathmandu Darjeeling Gangtok", "tourImageUrl": this.imageBaseUrl + "/BusPackages/21.jpeg" },
    { "id": 22, "tourName": "Saurastra Darshan - Kutch Darshan", "tourImageUrl": this.imageBaseUrl + "/BusPackages/22.jpeg" },
  ];

  serviceBaseURL: string = environment.serviceBaseUrl;
  selectedTourId: number = null;
  selectedName: string = null;

  constructor(private http: HttpClient) {
  }

  getAboutUs(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetAboutUs').toPromise();
  }

  editAboutUs(account): Promise<any> {
    return this.http.post(this.serviceBaseURL + "Kesavi/EditAboutUs", account).toPromise();
  }

  FileDelete(id, filename, parentFolder): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/FileDelete?id=' + id + "&filename=" + filename + "&parentFolder=" + parentFolder).toPromise();
  }

}
